import { render, staticRenderFns } from "./activateResult.vue?vue&type=template&id=5de51ca3&scoped=true&"
import script from "./activateResult.vue?vue&type=script&lang=js&"
export * from "./activateResult.vue?vue&type=script&lang=js&"
import style0 from "./activateResult.vue?vue&type=style&index=0&id=5de51ca3&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.9.6@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5de51ca3",
  null
  
)

export default component.exports